@if(this.notificationStore.isLoading()) {
  <div class="custom-loading-container">
      <ion-backdrop [visible]="true" />
      <ion-button class="custom-loading-close" color="light" fill="solid" shape="round" size="small" [attr.aria-label]="'messages.closeLoading' | translate" (click)="dismiss()">
        <ion-icon name="close-outline" slot="icon-only" />
      </ion-button>
      <div class="custom-loading-message">
        <ods-loader class="ods-spinner-large" />
        <ion-grid>
            @for (notification of this.notificationStore.notificationData()?.notificationList; track notification ) {
              <ion-row>
                  <ion-col class="ion-text-end">
                      <ion-text class="capitalize">{{notification.description}}</ion-text>
                  </ion-col>
                  <ion-col class="ion-text-start" size="5">
                    @if (notification.isLoaded) {
                      <ion-icon color="success" name="checkmark-done-circle-outline" />
                    } @else {
                      <ods-loader class="ods-spinner-small" />
                    }
                  </ion-col>
              </ion-row>
            }
          </ion-grid>
      </div>
  </div>
}
